import {
	getProduct,
	getProductsForUpgrade,
	getDiscountData as getDiscountDataRequest,
	getTrialProduct,
} from "../../domain/product"

export const PRODUCTS_SET = "PRODUCTS_SET"
export const PRODUCTS_REQUEST = "PRODUCTS_REQUEST"
export const PRODUCTS_REQUEST_DONE = "PRODUCTS_REQUEST_DONE"
export const PRODUCT_TO_PURCHASE_SET = "PRODUCT_TO_PURCHASE_SET"
export const DISCOUNT_DATA_SET = "DISCOUNT_DATA_SET"

export const setProducts = data => ({ type: PRODUCTS_SET, payload: data })

export const getProducts = () => dispatch => {
	return getProductsForUpgrade().then(res => {
		dispatch(setProducts(res.data.data))
		dispatch(productsRequestDone())
		return res.data.data
	})
}

export const setProductForPurchase = data => ({ type: PRODUCT_TO_PURCHASE_SET, payload: data })

export const getProductForPurchase = (id, trial = false) => dispatch => {
	const request = trial ? getTrialProduct : getProduct

	return request(id).then(res => {
		dispatch(setProductForPurchase(res.data.data))
		dispatch(productsRequestDone())
		return res.data.data
	})
}

export const resetDiscountData = () => ({ type: DISCOUNT_DATA_SET, payload: {} })

export const setDiscountData = data => ({ type: DISCOUNT_DATA_SET, payload: data })

export const getDiscountData = (productId, discountCode) => dispatch => {
	return getDiscountDataRequest(productId, discountCode)
		.then(res => {
			dispatch(setDiscountData(res.data.data))
			return res.data.data
		})
		.catch(err => {
			// Only a 422 naming discount_code is this thunk's business. Reaching
			// straight for err.response.data.errors.discount_code[0] threw a
			// TypeError inside the catch for every other failure -- a dropped
			// connection, a 5xx, a 422 about some other field -- which replaced the
			// real error with a meaningless one and left the caller's form stuck in
			// `submitting` with nothing shown.
			const data = err && err.response && err.response.data
			const codeErrors = data && data.errors && data.errors.discount_code

			if (codeErrors && codeErrors.length) {
				dispatch(setDiscountData({ error: codeErrors[0] }))
				return
			}

			throw err
		})
}

export const productsRequest = () => ({ type: PRODUCTS_REQUEST })

export const productsRequestDone = () => ({ type: PRODUCTS_REQUEST_DONE })
